module.exports = __webpack_public_path__ + "static/media/1.18_preview.499d15ef.png";